<template>
  <div id="app">
    <div id="nav" class="container navbar">
      <div class="navbar-header"><img src="@/assets/osve-logo.png" alt="天堰OSVE" height="60"></div>
      <div class="navbar-text"><h1>天堰OSVE考试智能化管理平台</h1></div>
      <div class="navbar-nav">
        <ul class="nav">
					<li><router-link to="/">平台APP下载</router-link></li>
          <li><router-link to="/anytime-examination">云端随时考</router-link></li>
          <!-- <li><router-link to="/about">About</router-link></li>
          <li><router-link to="/color-box">ColorBox</router-link></li> -->
          <!-- <li><router-link to="/anytime-examination">云端随时考</router-link></li> -->
          
          <li><router-link to="/introduce">平台业务介绍</router-link></li>
        </ul>
        <div id="magic-line"></div>
        <!-- <router-link to="/">Home</router-link> |
        <router-link to="/about">About</router-link> |
        <router-link to="/color-box">ColorBox</router-link> |
        <router-link to="/anytime-examination">云端随时考</router-link> |
        <router-link to="/download">平台APP下载</router-link> |
        <router-link to="/introduce">平台业务介绍</router-link> -->
      </div>
    </div>
    <router-view />

    <div id="footer" class="container">
      <div class="col-6 text-right">版权所有：天津市医学堂科技有限公司</div>
      <div class="col-6" style="margin-bottom:5px;"><a href="http://www.beian.miit.gov.cn/">津ICP备16009068号</a></div>
      <div style="text-align: center;">
        <div style="height:20px;"></div>
        <a href="https://xyt.xcc.cn/getpcInfo?sn=1519237944789905408&language=CN&certType=8&url=*.osve.cn" target="_blank" style="position: relative;display: inline-block;height: 38px;">
          <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div><embed src="https://program.xinchacha.com/web/1519237944789905408=*.osve.cn.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  mounted: function() {
    console.log($(".router-link-exact-active"));
    setTimeout(function() {
      // 没 setTimeout，$(".router-link-exact-active") 取到的是第一个
      // 不知道 vue 设置 router-link-exact-active 的机制
      let mlWidth = $(".router-link-exact-active").width();
      let mlLeft = $(".router-link-exact-active").offset().left - $("#nav .navbar-nav").offset().left;
      $("#magic-line").css({"left": mlLeft +"px", "width": mlWidth +"px"});

      $(document).on("mouseenter", "#nav .navbar-nav a", function() {
        clearTimeout(leaveTimer);
        let mlWidth = $(this).width();
        let mlLeft = $(this).offset().left - $("#nav .navbar-nav").offset().left;
        $("#magic-line").animate({"left": mlLeft +"px", "width": mlWidth +"px"});
      });

      var leaveTimer;
      $(document).on("mouseleave", "#nav .navbar-nav a", function() {
        leaveTimer = setTimeout(function() {
          let mlWidth = $(".router-link-exact-active").width();
          let mlLeft = $(".router-link-exact-active").offset().left - $("#nav .navbar-nav").offset().left;
          $("#magic-line").animate({"left": mlLeft +"px", "width": mlWidth +"px"});
        }, 200);
      });
    }, 300);
  }
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  // -webkit-tap-highlight-color:rgba(0,0,0,0);
}

html, body {
  margin: 0;
  padding: 0;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

}

a, button, input {
  border: 0;

  &:focus { outline: none; }
}

body {
  overflow-y: scroll;
  background-color: #f0f0f0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  margin-bottom: 20px;
  height: 80px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .3);
  // padding: 30px;
  background-color: #fff;

  a {
    display: inline-block;
    height: 78px;
    font-size: 20px;
    font-weight: 500;
    color: #2c3e50;
    line-height: 95px;
    text-decoration: none;

    &.router-link-exact-active {
      color: #2478e6;
      // border-bottom: 2px solid #2478e6;
    }
  }
}

#footer {
  height: 200px;
  // background: #333;
  color: #aaa;

  a, a:visited { color: #aaa; }
  a:hover { color: #666; }
}

.container {
  margin: 0 auto;
  width: 1170px;
}

@media screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
and (orientation : landscape) {
  .container {
      width: 970px !important;
  }

  .navbar-text {
    margin-right: 80px !important;
  }

  #nav a { font-size: 16px !important; }
}

.nav {
  margin: 0;
  padding: 0;
  list-style: none;
}

.pull {
  &-left { float: left; }
  &-right { float: right; }
}

.navbar, .row, .nav, .clearfix {
  &:before { display: table; content: " "; }
  &:after { clear: both; display: table; content: " "; }
}

.navbar {
  // padding: 10px 0 !important;
  &-header { float: left; margin-right: 20px; width: 80px; height: 80px; padding: 10px; background-color: #ddd; }
  &-text {
    float: left; margin-right: 200px;
    h1 { margin: 0; font-size: 24px; font-weight: 400; line-height: 95px; }
  }
  &-nav { float: left; position: relative; margin: 0; height: 80px; line-height: 60px;}

  .nav li { float: left; height: 80px; padding: 0 25px; }
  #magic-line { position: absolute; bottom: 2px; height: 2px; background-color: #2478e6; }
}

.panel {
  margin-bottom: 20px;
  border-radius: 5px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .13);
  padding: 20px;
  background-color: #fff;
}

.badge {
  border-radius: 50%;
  text-align: center;

  &.yellow { background-color: #fbc127; }
  &.orange { background-color: #ee7f1a; }
  &.red { background-color: #f00; }
  &.blue { background-color: #2478e6; }
  &.green { background-color: #7ebf4f; }
}

.btn {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .3);
  cursor: pointer;
}

.row {
  margin-left: -15px;
  margin-right: -15px;
}

.col-1, .col-2, .col-3, .col-4, .col-5, .col-6,
.col-7, .col-8, .col-9, .col-10, .col-11, .col-12 {
    float: left;
    padding-left: 15px;
    padding-right: 15px;
}

.col {
  // &-1 { width: 8.33333333%; }
  // &-2 { width: 16.66666667%; }
  // &-3 { width: 25%; }
  // &-4 { width: 33.33333333%; }
  // &-5 { width: 41.66666667%; }
  // &-6 { width: 50%; }
  // &-7 { width: 58.33333333%; }
  // &-8 { width: 66.66666667%; }
  // &-9 { width: 75%; }
  // &-10 { width: 83.33333333%; }
  // &-11 { width: 91.66666667%; }
  // &-12 { width: 100%; }
  &-1 { width: calc(25%/3); }
  &-2 { width: calc(25%*2/3); }
  &-3 { width: 25%; }
  &-4 { width: calc(100%/3); }
  &-5 { width: calc(100%*5/12); }
  &-6 { width: 50%; }
  &-7 { width: calc(100%*4/12); }
  &-8 { width: calc(100%*2/3); }
  &-9 { width: 75%; }
  &-10 { width: calc(100%*5/6); }
  &-11 { width: calc(100%*11/12); }
  &-12 { width: 100%; }

  &-pd0 { padding: 0; }
  &-pd-left0 { padding-left: 0; }
  &-pd-right0 { padding-right: 0; }
}

.mt {
  &5 { margin-top: 5px !important; }
  &10 { margin-top: 10px !important; }
  &15 { margin-top: 15px !important; }
  &20 { margin-top: 20px !important; }
  &25 { margin-top: 25px !important; }
  &30 { margin-top: 30px !important; }
}

.text {
  &-center { text-align: center; }
  &-left { text-align: left; }
  &-right { text-align: right; }
  &-danger { color: #f00; }
  &-grey { color: #aaa; }
}
</style>
